const UUID_REGEX =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

export type TextPart = { type: "text"; value: string };
export type UuidPart = { type: "uuid"; value: string };
export type ParsedPart = TextPart | UuidPart;

/**
 * Parses text and splits it into text and UUID segments.
 * Used to render segment IDs as clickable links in reason details.
 */
export const parseSegmentLinks = (text: string): ParsedPart[] => {
  const parts: ParsedPart[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(UUID_REGEX)) {
    const uuid = match[0];
    const matchIndex = match.index;

    if (matchIndex > lastIndex) {
      parts.push({ type: "text", value: text.slice(lastIndex, matchIndex) });
    }

    parts.push({ type: "uuid", value: uuid });

    lastIndex = matchIndex + uuid.length;
  }

  if (lastIndex < text.length) {
    parts.push({ type: "text", value: text.slice(lastIndex) });
  }

  return parts;
};
